// import React, { useMemo } from 'react';
//  import ChatPreview from '../ChatPreview';
// import { resolveChatWidgetConfig } from '../../utils/chatWidgetConfig';

import React, { useMemo } from 'react';
import ChatWidgetView from '../ChatWidgetView';
import { resolveChatWidgetConfig } from '../../utils/chatWidgetConfig';

/** Purpose: Render a debug-panel section with an optional heading. Why: Preview and log panels share consistent sizing and grouping. */
const Section = ({ title, subtitle, children, compactHeader = false, className = '' }) => (
  <div className={`flex min-h-0 flex-col rounded-3xl border border-white/10 bg-slate-950/70 p-4 shadow-lg shadow-slate-950/30 ${className}`}>
    {compactHeader ? null : (
      <div>
        <div className="text-xs uppercase tracking-[0.26em] text-slate-500">{title}</div>
        {subtitle ? <div className="mt-1 text-xs text-slate-500">{subtitle}</div> : null}
      </div>
    )}
    <div className={compactHeader ? '' : 'mt-4'}>{children}</div>
  </div>
);

/** Purpose: Render the debug-control icon. Why: Testing controls need a compact visual identifier. */
const BugGlyph = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 6h8" />
    <path d="M9 3h6l1 3H8l1-3Z" />
    <path d="M10 14v6" />
    <path d="M14 14v6" />
    <path d="M5 10h14" />
    <path d="M7 10v4a5 5 0 0 0 10 0v-4" />
    <path d="M3 13h4" />
    <path d="M17 13h4" />
    <path d="m4 6 3 2" />
    <path d="m20 6-3 2" />
  </svg>
);

// export default function FlowDebuggerPanel({
//   sessionId,
//   traceId,
//   botLabel,
//   botName = 'Bot Preview',
//   widgetConfig = {},
//   history = [],
//   quickReplies = [],
//   variables = {},
//   inputControl = null,
//   currentNodeLabel = '',
//   debugInput = '',
//   onDebugInputChange,
//   onRunDebug,
//   onQuickReply,
//   onHomeDebug,
//   onResetDebug,
//   logsVisible = true,
//   onToggleLogs,
//   logHeight = 320,
//   onLogHeightChange,
//   onReplayConversation,
//   loading = false,
//   waitingForUserInput = false,
//   error = '',
// }) {
//   const resolvedWidgetConfig = useMemo(
//     () => resolveChatWidgetConfig(widgetConfig, botName),
//     [widgetConfig, botName]
//   );
//   const previewMessages = useMemo(() => {
//     if (Array.isArray(history) && history.length > 0) {
//       return history.map((item, index) => ({
//         id: `${item.role || 'bot'}-${index}`,
//         role: item.role || 'bot',
//         text: item.text || '',
//         mediaUrl: item.mediaUrl || '',
//         mediaType: item.mediaType || '',
//         alt: item.alt || '',
//       }));
//     }

//     return [
//       {
//         id: 'initial-preview',
//         role: 'bot',
//         text: 'Preview is ready. Use Home or send a message to start the flow.',
//       },
//     ];
//   }, [history]);

//   return (
//     <div className="flex h-full min-h-0 flex-col gap-1.5 overflow-hidden">
//       <Section
//         title="Bot Preview"
//         subtitle=""
//         compactHeader
//         className="flex-1 min-h-0 p-3"
//       >
//         {/* <div className="flex min-h-0 flex-[0.20] flex-col overflow-hidden rounded-[28px] border border-white/10"> */}
//         <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-[28px] border border-white/10 max-h-[75vh]">
//           <ChatPreview
//             title={resolvedWidgetConfig.title}
//             subtitle={resolvedWidgetConfig.subtitle}
//             botName={resolvedWidgetConfig.title}
//             status={loading ? 'Typing...' : resolvedWidgetConfig.statusText}
//             avatarText={resolvedWidgetConfig.avatarText}
//             avatarUrl={resolvedWidgetConfig.avatarUrl}
//             showHeader={resolvedWidgetConfig.showHeader}
//             showAvatar={resolvedWidgetConfig.showAvatar}
//             showTitle={resolvedWidgetConfig.showTitle}
//             showSubtitle={resolvedWidgetConfig.showSubtitle}
//             showStatus={resolvedWidgetConfig.showStatus}
//             showReset={resolvedWidgetConfig.showReset}
//             resetLabel={resolvedWidgetConfig.resetLabel}
//             messages={previewMessages}
//             typing={loading}
//             inputValue={debugInput}
//             onInputChange={onDebugInputChange}
//             onSend={(value) => onRunDebug?.(value)}
//             onQuickReply={onQuickReply}
//             onReset={onResetDebug}
//             onHome={onHomeDebug}
//             quickReplies={quickReplies}
//             inputType={inputControl?.inputType || 'text'}
//             dateValidation={inputControl?.dateValidation || {}}
//             placeholder={inputControl?.placeholder || resolvedWidgetConfig.inputPlaceholder}
//             footerHint="Home = default journey start. Send = current conversation continue."
//             themeMode={resolvedWidgetConfig.themeMode}
//             primaryColor={resolvedWidgetConfig.primaryColor}
//             accentColor={resolvedWidgetConfig.brandColorMode === 'gradient' ? resolvedWidgetConfig.secondaryColor : resolvedWidgetConfig.accentColor}
//             complementaryColor={resolvedWidgetConfig.complementaryColor}
//             fontFamily={resolvedWidgetConfig.fontStyle === 'custom' ? resolvedWidgetConfig.fontFamily : 'inherit'}
//             fontSize={resolvedWidgetConfig.fontSize}
//             textSize={resolvedWidgetConfig.textSize}
//             textColor={resolvedWidgetConfig.textColor}
//           />
//         </div>

//         <div className="mt-1 shrink-0 rounded-2xl border border-white/10 bg-white/5 px-2 py-1.5">
//           <div className="grid min-w-0 grid-cols-3 gap-1">
//             <button
//               type="button"
//               onClick={onHomeDebug}
//               disabled={loading}
//               title="Start from Home"
//               className="inline-flex h-8 w-full items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-cyan-400/20 bg-cyan-500/10 px-2 text-[9px] font-medium text-cyan-100 transition hover:bg-cyan-500/15 disabled:cursor-not-allowed disabled:opacity-50 sm:text-[10px]"
//             >
//               Home
//             </button>
//             <button
//               type="button"
//               onClick={onReplayConversation}
//               disabled={loading}
//               title="Replay conversation"
//               className="inline-flex h-8 w-full items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-violet-400/20 bg-violet-500/10 px-2 text-[9px] font-medium text-violet-100 transition hover:bg-violet-500/15 disabled:cursor-not-allowed disabled:opacity-50 sm:text-[10px]"
//             >
//               Replay
//             </button>
//             <button
//               type="button"
//               onClick={() => onToggleLogs?.()}
//               title={logsVisible ? 'Hide logs' : 'Show logs'}
//               className="inline-flex h-8 w-full items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-white/10 bg-white/5 px-2 text-[9px] font-medium text-slate-100 transition hover:border-cyan-400/40 hover:bg-cyan-500/10 hover:text-cyan-200 sm:text-[10px]"
//             >
//               <BugGlyph />
//               {logsVisible ? 'Hide' : 'Logs'}
//             </button>
//           </div>
//         </div>

//         {error ? (
//           <div className="mt-3 rounded-2xl border border-rose-400/20 bg-rose-500/10 px-4 py-3 text-sm text-rose-200">
//             {error}
//           </div>
//         ) : null}

//         {variables && Object.keys(variables).length > 0 ? (
//           <div className="mt-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-3">
//             <div className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-400">
//               Live variables
//             </div>
//             <pre className="mt-2 max-h-40 overflow-auto whitespace-pre-wrap break-all text-[11px] leading-5 text-slate-300">
//               {JSON.stringify(variables, null, 2)}
//             </pre>
//           </div>
//         ) : null}
//       </Section>
//     </div>
//   );
// }
/** Purpose: run and inspect a flow preview/debug session. Why: authors need a safe interactive test loop before publishing changes. */
export default function FlowDebuggerPanel({
  sessionId,
  traceId,
  botLabel,
  botName = 'Bot Preview',
  widgetConfig = {},
  history = [],
  quickReplies = [],
  variables = {},
  inputControl = null,
  currentNodeLabel = '',
  debugInput = '',
  onDebugInputChange,
  onRunDebug,
  onQuickReply,
  onHomeDebug,
  onResetDebug,
  onAttachment,
  logsVisible = true,
  onToggleLogs,
  logHeight = 320,
  onLogHeightChange,
  onReplayConversation,
  loading = false,
  waitingForUserInput = false,
  error = '',
}) {
  /** Purpose: Resolve widget appearance from configuration and bot name. Why: Preview should use the widget's branding defaults. */
  const resolvedWidgetConfig = useMemo(
    () => resolveChatWidgetConfig(widgetConfig, botName),
    [widgetConfig, botName]
  );

  /** Purpose: Convert history into consistent preview-message fields. Why: Debug history and fallback content need one rendering contract. */
  const previewMessages = useMemo(() => {
    if (Array.isArray(history) && history.length > 0) {
      return history.map((item, index) => ({
        id: `${item.role || 'bot'}-${index}`,
        role: item.role || 'bot',
        text: item.text || '',
        mediaUrl: item.mediaUrl || '',
        mediaType: item.mediaType || '',
        alt: item.alt || '',
      }));
    }

    return [
      {
        id: 'initial-preview',
        role: 'bot',
        text: 'Preview is ready. Use Home or send a message to start the flow.',
      },
    ];
  }, [history]);

  const sectionSubtitle = [
    botLabel || '',
    currentNodeLabel ? `Node: ${currentNodeLabel}` : '',
    waitingForUserInput ? 'Waiting for input' : '',
  ]
    .filter(Boolean)
    .join(' • ');

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <Section
        title="Bot Preview"
        subtitle={sectionSubtitle}
        compactHeader
        className="flex min-h-0 flex-1 flex-col"
      >
        {/* ===============================================
            COMMON CHAT UI
            Preview + Live dono isi ChatWidgetView ko use karenge
        =============================================== */}

        <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-[28px] border border-white/10 max-h-[75vh]">
          <ChatWidgetView
            widgetConfig={resolvedWidgetConfig}
            messages={previewMessages}
            loading={loading}
            inputValue={debugInput}
            onInputChange={onDebugInputChange}
            onSend={(value, payload) => onRunDebug?.(value, payload)}
            quickReplies={quickReplies}
            onQuickReply={onQuickReply}
            onReset={onResetDebug}
            onHome={onHomeDebug}
            onAttachment={onAttachment}
            inputControl={inputControl}
            footerHint="Home = default journey start. Send = current conversation continue."
          />
        </div>

        {/* ===============================================
            DEBUG ACTIONS
        =============================================== */}

        <div className="mt-1 shrink-0 rounded-2xl border border-white/10 bg-white/5 px-2 py-1.5">
          <div className="grid min-w-0 grid-cols-3 gap-1">
            <button
              type="button"
              onClick={onHomeDebug}
              disabled={loading}
              title="Start from Home"
              className="inline-flex h-8 w-full items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-cyan-400/20 bg-cyan-500/10 px-2 text-[9px] font-medium text-cyan-100 transition hover:bg-cyan-500/15 disabled:cursor-not-allowed disabled:opacity-50 sm:text-[10px]"
            >
              Home
            </button>

            <button
              type="button"
              onClick={onReplayConversation}
              disabled={loading}
              title="Replay conversation"
              className="inline-flex h-8 w-full items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-violet-400/20 bg-violet-500/10 px-2 text-[9px] font-medium text-violet-100 transition hover:bg-violet-500/15 disabled:cursor-not-allowed disabled:opacity-50 sm:text-[10px]"
            >
              Replay
            </button>

            <button
              type="button"
              onClick={() => onToggleLogs?.()}
              title={logsVisible ? 'Hide logs' : 'Show logs'}
              className="inline-flex h-8 w-full items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-white/10 bg-white/5 px-2 text-[9px] font-medium text-slate-100 transition hover:border-cyan-400/40 hover:bg-cyan-500/10 hover:text-cyan-200 sm:text-[10px]"
            >
              <BugGlyph />

              {logsVisible ? 'Hide' : 'Logs'}
            </button>
          </div>
        </div>

        {/* ===============================================
            SESSION INFO
        =============================================== */}

        {(sessionId || traceId) ? (
          <div className="mt-2 rounded-2xl border border-white/10 bg-white/5 px-3 py-2 text-[10px] leading-5 text-slate-400">
            {sessionId ? (
              <div className="break-all">
                <span className="font-semibold text-slate-300">
                  Session:
                </span>{' '}
                {sessionId}
              </div>
            ) : null}

            {traceId ? (
              <div className="break-all">
                <span className="font-semibold text-slate-300">
                  Trace:
                </span>{' '}
                {traceId}
              </div>
            ) : null}
          </div>
        ) : null}

        {/* ===============================================
            ERROR
        =============================================== */}

        {error ? (
          <div className="mt-3 rounded-2xl border border-rose-400/20 bg-rose-500/10 px-4 py-3 text-sm text-rose-200">
            {error}
          </div>
        ) : null}

        {/* ===============================================
            VARIABLES
        =============================================== */}

        {variables && Object.keys(variables).length > 0 ? (
          <div className="mt-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-3">
            <div className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-400">
              Live variables
            </div>

            <pre className="mt-2 max-h-40 overflow-auto whitespace-pre-wrap break-all text-[11px] leading-5 text-slate-300">
              {JSON.stringify(variables, null, 2)}
            </pre>
          </div>
        ) : null}
      </Section>
    </div>
  );
}
